'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./time-picker-button.scss');

var _classnames = require('../../../utils/classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function TimePickerButton(_ref) {
  var color = _ref.color,
      children = _ref.children,
      className = _ref.className,
      background = _ref.background,
      size = _ref.size,
      props = _objectWithoutProperties(_ref, ['color', 'children', 'className', 'background', 'size']);

  var classes = (0, _classnames2.default)('time-picker-button', color && 'time-picker-button--color-' + color, background && 'time-picker-button--background-' + background, 'time-picker-button--size-' + size, className);

  return _react2.default.createElement(
    'button',
    _extends({ className: classes, type: 'button' }, props),
    children
  );
}

TimePickerButton.propTypes = {
  className: _propTypes2.default.string,
  children: _propTypes2.default.node,
  color: _propTypes2.default.oneOf(['secondary']),
  background: _propTypes2.default.oneOf(['secondary']),
  size: _propTypes2.default.oneOf(['large', 'xx-large']),
  onClick: _propTypes2.default.func
};

TimePickerButton.defaultProps = {
  size: 'large'
};

exports.default = TimePickerButton;